import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_DOCUMENTS = gql`
  query fetchFileDocuments($filter: FileDocumentQueryFilter) {
    fetchFileDocuments(
      input: { filter: $filter, pagination: { perPage: 1000 } }
    ) {
      fileDocuments {
        id
        type
        name
        fileName
        mediaType
        uploadedAt
        updatedAt
        objectType
        objectId
        sharedClient
        sharedCustodian
        creator {
          id
        }
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const FETCH_ALL_USER_AGREEMENTS = (permissions: string[]) => gql`
  query fetchAllUserAgreements($id: SafeString!) {
    fetchUser(input: { userId: $id }) {
      user {
        id: stringId
        ${permissions.includes('read:client_low_risk_pii') ? 'firstName lastName' : ''}
        allLatestFormAgreements {
          id
          account { id }
          user { id }
          goal { id }
          subAccount { id }
          scheduledTransfer { id state frequency subAccount { id account { type } } }
          displayName
          type
          signedAt
          signedUrl
          templateUrl
          financialProduct { id }
        }
        allIncompleteFormAgreements {
          id
          account { id }
          user { id }
          goal { id }
          subAccount { id }
          scheduledTransfer { id state frequency subAccount { id account { type } } }
          translatedDisplayName { ${TRANSLATED_STRING_FIELDS} }
          type
          changeType
          templateUrl
          isPrefilledPdfEnabled
          digitalSignatureEnabled
          minVersion
        }
      }
    }
  }
`;

export const FETCH_ACCOUNT_AGREEMENTS = gql`
  query fetchAccountAgreements($id: SafeString!) {
    fetchAccount(input: { accountId: $id }) {
      account {
        id: stringId
        latestFormAgreements { id displayName type signedAt signedUrl templateUrl }
        incompleteFormAgreements { id translatedDisplayName { ${TRANSLATED_STRING_FIELDS} } type changeType templateUrl isPrefilledPdfEnabled digitalSignatureEnabled minVersion }
      }
    }
  }
`;

export const FETCH_CLIENT_GROUP_AGREEMENTS = gql`
  query fetchClientGroupAgreements($id: SafeString!) {
    fetchClientGroup(input: { clientGroupId: $id }) {
      clientGroup {
        id: stringId
        latestFormAgreements { id displayName type signedAt signedUrl templateUrl }
        incompleteFormAgreements { id translatedDisplayName { ${TRANSLATED_STRING_FIELDS} } type changeType templateUrl isPrefilledPdfEnabled digitalSignatureEnabled minVersion }
      }
    }
  }
`;
